import { Box, Typography } from "@mui/material";
import ReactApexChart from "react-apexcharts";
import { hoursDecimalToHM } from "src/utils";

const colors = [
  "#A155B9",
  "#CC9C33",
  "#CC3723",
  "#0075FF",
  "#16AA75",
  "#EB1DB1",
  "#3528C1",
];

const AvgStayBreakDownChart = ({
  data,
}: {
  data: {
    avgParkingHours: number;
    locationName: string;
  }[];
}) => {
  const locationsNames: string[] = [];
  const locationsSales: number[] = [];

  let total = 0;

  data?.forEach((item) => {
    const avgParking = item.avgParkingHours || 0;
    locationsNames.push(item.locationName || "");
    locationsSales.push(avgParking || 0);
    total += avgParking;
  });

  const options: ApexCharts.ApexOptions = {
    chart: {
      redrawOnParentResize: true,
      width: 80,
      type: "pie",
      foreColor: "#FFF",
    },
    noData: {
      text: "No data available ",
      style: {
        fontSize: "15px",
      },
    },
    colors: colors,
    labels: locationsNames,
    stroke: {
      show: false,
    },
    dataLabels: {
      enabled: false,
    },
    legend: {
      formatter: function (val, opts) {
        return (
          val +
          " - " +
          (
            (opts.w.globals.series[opts.seriesIndex] / total) * 100 || 0
          ).toFixed(1) +
          "%"
        );
      },
    },
    tooltip: {
      y: {
        formatter: (value: number): string =>
          `${hoursDecimalToHM(+value)?.toString()}`,
      },
    },
  };

  return (
    <Box
      borderRadius={"12px"}
      overflow={"hidden"}
      pb={"10px"}
      bgcolor={"#242424"}
      height={"100%"}
    >
      <Box padding={"21px 24px"} bgcolor={"#242424"}>
        <Typography fontSize={"20px"} fontWeight={700}>
          Average Stay Time Breakdown
        </Typography>
      </Box>
      <Box height={"2px"} bgcolor={"#000000"} />
      <Box pr={{ xs: "0", md: "150px" }} pb={1} pt={4} height={"100%"}>
        <ReactApexChart
          options={options}
          series={locationsSales}
          type="pie"
          height={250}
          width={"100%"}
        />
      </Box>
    </Box>
  );
};

export default AvgStayBreakDownChart;
